import React from 'react';
import PropTypes from 'prop-types';
import round from '../../../helpers/round';
import f2Grapgh from '../../../assets/calculations/stroud/f2.JPG';

const GRAPH_WIDTH = 300;
const f2Image = { width: 579, height: 431 };

// Calibrated from debug points (PI 20-60)
// Quadratic x mapping (fits PI 20-60 precisely)
const F2_X_A = 0.00007142857143;
const F2_X_B = 3.309285714286;
const F2_X_C = 52.08;
const F2_Y_SLOPE = -0.170381435;
const F2_Y_INTERCEPT = 186.482886;

const buildF2Graph = (pi, f2) => {
  const height = (GRAPH_WIDTH * f2Image.height) / f2Image.width;
  const baseX = F2_X_A * pi * pi + F2_X_B * pi + F2_X_C;
  const x =
    pi >= 15 && pi <= 25
      ? baseX - 3
      : pi > 25 && pi <= 40
        ? baseX - 2
        : pi > 40 && pi <= 70
          ? baseX - 1
          : baseX;
  const y = F2_Y_INTERCEPT + F2_Y_SLOPE * f2;

  return {
    width: GRAPH_WIDTH,
    height,
    x,
    verticalTopY: y,
    verticalBottomY: F2_Y_INTERCEPT,
    horizontalY: y,
    horizontalX1: F2_X_C,
    horizontalX2: x,
    labelX: F2_X_C + 2,
    labelY: y - 5,
  };
};

const StroudF2GraphSvg = ({ pi, f2, showOverlay }) => {
  const piValue = Number(pi);
  const f2Value = Number(f2);
  const graph = buildF2Graph(piValue, f2Value);

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${graph.width} ${graph.height}`}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Stroud f2 correlation graph"
      style={{ display: 'block', width: '100%', height: 'auto', aspectRatio: `${graph.width} / ${graph.height}` }}
    >
      <image href={f2Grapgh} x="0" y="0" width={graph.width} height={graph.height} />
      {showOverlay && (
        <g stroke="#b33a3a" fill="none" strokeWidth="2" vectorEffect="non-scaling-stroke">
          <line x1={graph.x} y1={graph.verticalTopY} x2={graph.x} y2={graph.verticalBottomY} />
          <polyline points={`${graph.x - 3},${graph.verticalTopY + 5} ${graph.x},${graph.verticalTopY} ${graph.x + 3},${graph.verticalTopY + 5}`} />
          <line x1={graph.horizontalX1} y1={graph.horizontalY} x2={graph.horizontalX2} y2={graph.horizontalY} />
          <polyline
            points={`${graph.horizontalX1 + 6},${graph.horizontalY - 3} ${graph.horizontalX1 + 1},${graph.horizontalY} ${graph.horizontalX1 + 6},${graph.horizontalY + 3}`}
          />
        </g>
      )}
      {showOverlay && (
        <text x={graph.labelX} y={graph.labelY - 2} fill="#b33a3a" fontSize="9" fontWeight="700">
          f<tspan baselineShift="sub" fontSize="7">2</tspan>={round(f2Value, 2)}
        </text>
      )}
    </svg>
  );
};

StroudF2GraphSvg.propTypes = {
  pi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  f2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showOverlay: PropTypes.bool,
};

StroudF2GraphSvg.defaultProps = {
  showOverlay: false,
};

export default React.memo(StroudF2GraphSvg);
